/**
 * Whether a gallery item passes the selected connector-gallery filter.
 *
 * `"all"` shows everything; `"connected"` shows connected items; any other value
 * is a category slug and shows only items tagged with it. An item with no
 * categories matches no category slug, so it appears only under `"All"` — the
 * behavior the gallery design asks for, and it falls out for free.
 *
 * Shared by the native gallery and web's so the filter semantics can't drift.
 * Typed structurally (not to `ConnectorCatalogItem`) so web's `GalleryItem` view
 * model, which folds in local non-catalog tiles like WhatsApp, also passes.
 * Search is applied separately (see `matchesConnectorSearch`).
 */
export const matchesConnectorGalleryFilter = (
  item: { connected: boolean; categories: string[] },
  filter: string,
): boolean => {
  if (filter === "all") return true;
  if (filter === "connected") return item.connected;
  return item.categories.includes(filter);
};

/**
 * Sort comparator that floats already-connected connectors to the top of a
 * gallery list, then orders by name within each group. Applied to the full list
 * so the connected-first ordering survives any category filter. Shared by the
 * native and web galleries.
 */
export const compareConnectorsConnectedFirst = (
  a: { connected: boolean; name: string },
  b: { connected: boolean; name: string },
): number => {
  if (a.connected !== b.connected) return a.connected ? -1 : 1;
  return a.name.localeCompare(b.name);
};
